module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal",
    attrs: {
      "id": "Modal",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "exampleModalLabel",
      "aria-hidden": "true"
    }
  }, [(_vm.task) ? _c('div', {
    staticClass: "modal__content modal__content--lg",
    attrs: {
      "id": "ModalContent"
    }
  }, [_c('div', {
    staticClass: "flex items-center px-5 py-5 sm:py-3 border-b border-gray-200"
  }, [_c('h2', {
    staticClass: "font-medium text-base mr-auto"
  }, [_vm._v("\n            " + _vm._s(_vm.task.name) + " - ("), _c('b', [_vm._v(_vm._s(_vm.task.date) + ")")])]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('closeModal')
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "intro-y box py-5"
  }, [_c('div', {
    staticClass: "wizard flex flex-col px-5 scroll-modal"
  }, [_c('div', {
    staticClass: "bg-gray-200 p-2 rounded-md"
  }, [_c('p', {
    staticClass: "mb-2"
  }, [_vm._v("\n                " + _vm._s(_vm.task.campaign_attribute.project_name) + " -\n                " + _vm._s(_vm.task.campaign_attribute.project_account_name) + " -\n                " + _vm._s(_vm.task.campaign_attribute.project_account_country_prefix) + " -\n                " + _vm._s(_vm.task.campaign_attribute.name) + "\n              ")]), _vm._v(" "), _c('p', {
    staticClass: "mb-2"
  }, [_c('b', [_vm._v("Creada el día:")]), _vm._v(" " + _vm._s(_vm.task.created_at) + "\n                "), _c('b', [_vm._v("por")]), _vm._v(" " + _vm._s(_vm.task.user_created_name) + "\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "mb-2"
  }, [_vm._v("\n                " + _vm._s(_vm.task.description) + " "), _c('br'), _vm._v(" "), (_vm.task.path) ? _vm._l((_vm.task.path.split(',')), function(taskPath) {
    return _c('a', {
      staticClass: "text-blue-500",
      attrs: {
        "href": taskPath,
        "target": "_blank"
      }
    }, [_vm._v("\n                    Ver archivo aquí\n                    "), _c('span', {
      staticClass: "text-gray-500"
    }, [_vm._v(",")])])
  }) : _vm._e()], 2), _vm._v(" "), _c('p', {
    staticClass: "mb-2"
  }, [_vm._v("\n                La tarea fue realizada por "), _c('b', [_vm._v(_vm._s(_vm.task.user_name))]), _vm._v(" en un total\n                de "), _c('b', [_vm._v(_vm._s(_vm.task.hours))]), _vm._v(" hora(s)\n              ")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('p', {
    staticClass: "mb-2"
  }, [_vm._v("\n                " + _vm._s(_vm.task.response_observations) + " "), (_vm.task.response_observations) ? _c('br') : _vm._e(), _vm._v(" "), (_vm.task.response_path) ? _vm._l((_vm.task.response_path.split(',')), function(taskResponsePath) {
    return _c('a', {
      staticClass: "text-blue-500",
      attrs: {
        "href": taskResponsePath,
        "target": "_blank"
      }
    }, [_vm._v("\n                    Ver archivo aquí\n                    "), _c('span', {
      staticClass: "text-gray-500"
    }, [_vm._v(",")])])
  }) : _vm._e()], 2)]), _vm._v(" "), _c('hr', {
    staticClass: "my-3"
  }), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('hr', {
    staticClass: "mb-2"
  }), _vm._v(" "), _vm._l((_vm.versions), function(version, index) {
    return _c('div', {
      key: version.id,
      staticClass: "bg-gray-100 rounded-md mb-2 p-2"
    }, [_c('p', {
      staticClass: "mb-2"
    }, [_vm._v("\n                " + _vm._s(version.campaign_attribute.project_name) + " -\n                " + _vm._s(version.campaign_attribute.project_account_name) + " -\n                " + _vm._s(version.campaign_attribute.project_account_country_prefix) + " -\n                " + _vm._s(version.campaign_attribute.name) + " -\n                " + _vm._s(("Versión " + (index + 1))) + "\n              ")]), _vm._v(" "), _c('p', {
      staticClass: "mb-2"
    }, [_c('b', [_vm._v("Creada el día:")]), _vm._v(" " + _vm._s(version.created_at) + "\n                "), _c('b', [_vm._v("por")]), _vm._v(" " + _vm._s(version.user_created_name) + "\n              ")]), _vm._v(" "), _c('div', {
      staticClass: "mb-2"
    }, [_vm._v("\n                " + _vm._s(version.description) + " "), _c('br'), _vm._v(" "), (version.path) ? _vm._l((version.path.split(',')), function(taskPath) {
      return _c('a', {
        staticClass: "text-blue-500",
        attrs: {
          "href": taskPath,
          "target": "_blank"
        }
      }, [_vm._v("\n                    Ver archivo aquí\n                    "), _c('span', {
        staticClass: "text-gray-500"
      }, [_vm._v(",")])])
    }) : _vm._e()], 2), _vm._v(" "), _c('p', {
      staticClass: "mb-2"
    }, [_vm._v("\n                La tarea fue realizada por "), _c('b', [_vm._v(_vm._s(version.user_name))]), _vm._v(" en un total\n                de "), _c('b', [_vm._v(_vm._s(version.hours))]), _vm._v(" hora(s)\n              ")]), _vm._v(" "), _vm._m(2, true), _vm._v(" "), _c('p', {
      staticClass: "mb-2"
    }, [_vm._v("\n                " + _vm._s(version.response_observations) + " "), (version.response_observations) ? _c('br') : _vm._e(), _vm._v(" "), (version.response_path) ? _vm._l((version.response_path.split(',')), function(taskResponsePath) {
      return _c('a', {
        staticClass: "text-blue-500",
        attrs: {
          "href": taskResponsePath,
          "target": "_blank"
        }
      }, [_vm._v("\n                    Ver archivo aquí\n                    "), _c('span', {
        staticClass: "text-gray-500"
      }, [_vm._v(",")])])
    }) : _vm._e()], 2)])
  })], 2)])]) : _c('app-loading')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "mb-2"
  }, [_c('b', [_vm._v("Respuesta")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "mb-2 text-center text-blue-800"
  }, [_c('b', [_vm._v("Versiones")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "mb-2"
  }, [_c('b', [_vm._v("Respuesta")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0995e458","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/task/ViewTaskModal.vue
// module id = 407
// module chunks = 1